var _circle, _circle2, _circle3, _path, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgPuzzle(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 422,
    viewBox: "0 0 640 422",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 8,
    transform: "matrix(1 0 0 -1 9 108.453)",
    stroke: "#67466C",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 8,
    transform: "matrix(1 0 0 -1 631 108.453)",
    stroke: "#67466C",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 8,
    transform: "matrix(1 0 0 -1 320 412.453)",
    stroke: "#67466C",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M428 108.953c0 59.371-48.129 107.5-107.5 107.5m107.5-107.5c0-59.37-48.129-107.5-107.5-107.5S213 49.583 213 108.953m215 0h195m-302.5 107.5c-59.371 0-107.5-48.129-107.5-107.5m107.5 107.5v187M213 108.953H17.5",
    stroke: "#67466C",
    strokeLinecap: "round",
    strokeDasharray: "14 14"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#puzzle_svg__filter0_d_33_7558)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 109.453,
    r: 82,
    fill: "#E4B1F6"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M281.885 116.17l-.895-.873.895.873zm43.398-44.474l.895.873-.895-.873zm29.629 28.912l-.894-.873.894.873zm-43.399 44.475l.895.873-.895-.873zm-29.27.358l-.873.894.873-.894zm72.311-74.103l-.873.894.873-.894zm-2.476 60.323a1.25 1.25 0 000-2.5v2.5zm-17.367-2.5a1.25 1.25 0 100 2.5v-2.5zm-28.017-37.037a1.25 1.25 0 10-2.492-.203l2.492.203zm-23.915 24.919l43.399-44.474-1.789-1.746-43.399 44.474 1.789 1.746zm71.239-17.308l-6.437 6.597 1.789 1.746 6.437-6.597-1.789-1.746zm-34.603 35.461l-8.796 9.014 1.789 1.746 8.796-9.014-1.789-1.746zm-36.299 9.35c-7.688-7.502-7.839-19.815-.337-27.503l-1.789-1.746c-8.466 8.676-8.296 22.572.38 31.038l1.746-1.789zm-1.746 1.789c8.676 8.466 22.572 8.296 31.038-.379l-1.789-1.746c-7.502 7.687-19.816 7.838-27.503.336l-1.746 1.789zm72.311-74.103c7.688 7.502 7.838 19.816.337 27.503l1.789 1.746c8.466-8.675 8.296-22.572-.38-31.038l-1.746 1.79zm1.746-1.789c-8.676-8.466-22.572-8.296-31.038.38l1.789 1.746c7.502-7.688 19.815-7.838 27.503-.337l1.746-1.789zm9.702 59.968c0 12.035-9.757 21.792-21.792 21.792v2.5c13.416 0 24.292-10.876 24.292-24.292h-2.5zm-21.792 21.792c-12.036 0-21.792-9.757-21.792-21.792h-2.5c0 13.416 10.876 24.292 24.292 24.292v-2.5zm0-43.584c12.035 0 21.792 9.757 21.792 21.792h2.5c0-13.416-10.876-24.292-24.292-24.292v2.5zm-21.792 21.792a21.69 21.69 0 014.218-12.889l-2.015-1.48a24.191 24.191 0 00-4.703 14.369h2.5zm4.218-12.889c3.969-5.401 10.362-8.903 17.574-8.903v-2.5c-8.041 0-15.169 3.908-19.589 9.923l2.015 1.48zm-.336-1.795c-3.411-2.172-8.359-5.477-12.336-9.599-3.999-4.145-6.813-8.905-6.397-14.004l-2.492-.203c-.503 6.175 2.916 11.616 7.09 15.943 4.197 4.35 9.362 7.788 12.792 9.972l1.343-2.109zm9.284 15.934h17.367v-2.5h-17.367v2.5z",
    fill: "#564793"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "puzzle_svg__filter0_d_33_7558",
    x: 227,
    y: 27.453,
    width: 188,
    height: 188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0677643 0 0 0 0 0.26974 0 0 0 0 0.306463 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33_7558"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_33_7558",
    result: "shape"
  })))));
}
export default SvgPuzzle;